import React from 'react';
import clsx from 'clsx';
import { type FCC } from 'types';
import getLinkAriaLabel from './getLinkAriaLabel';
import styles from './Link.module.scss';

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string;
  className?: string;
  target?: string;
  ariaLabel?: string;
}

const Link: FCC<LinkProps> = ({ href, className, children, target, ariaLabel, ...props }) => {
  const label = getLinkAriaLabel({ children, target, ariaLabel, href });

  return (
    <a
      className={clsx(styles.link, className)}
      href={href}
      target={target}
      {...props}
      {...(label && { 'aria-label': label })}
    >
      {children}
    </a>
  );
};

export default Link;
